
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import * as auth from '../redux/AuthRedux'
import { login, saml } from '../redux/AuthCRUD'
import { callSP } from '../../../../setup/axios/AxiosCallSP'
import { warn } from 'app/utils/customToasd'
import { CacheSitesUserService } from './services/cache-ceco-user/cache-ceco-user.service'

const loginSchema = Yup.object().shape({
  user: Yup.string()
    // .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('User is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})
const initialValues = {
  user: '',
  password: '',
}
const isDev = (window.location.hostname.includes('localhost')
  || window.location.hostname.includes('dev-net.goplicity')
  || window.location.hostname.includes('amddev.sodexhochile.cl'))

const API_URL = isDev ? process.env.REACT_APP_API_URL_QAS : process.env.REACT_APP_API_URL
const URL_SAML = process.env.REACT_APP_API_URL_SAML
const URL_SAML_RETURN = process.env.REACT_APP_API_URL_SAML_RETURN

export const LOGIN_URL = `${API_URL}/Authenticate/Login`

export function postSaml(user: string, password: string, asml: string) {
  login(user, password, asml)
    .then((data) => {
      var response_saml = data.data.response_saml
      var response_saml_encode = encodeURIComponent(response_saml)
      getMicrosoft(response_saml_encode)

    })
}


export function getMicrosoft(base_64: string) {
  var url = URL_SAML + "?"
  url += "SAMLRequest=" + base_64 + "&"
  url += "sso_reload=true"

  window.location.href = url;
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setTimeout(() => {
        login(values.user, values.password, URL_SAML_RETURN + "")
          .then(({ data: { result } }) => {
            if (result.id === undefined) {
              warn("Usuario o contraseña incorrecta!!!")
              setLoading(false)
              setSubmitting(false)
              return;
            }
            if (result.role == 12) {
              const cacheService = new CacheSitesUserService();
              cacheService.getCacheSitesPerUser(result).subscribe();
            }
            const mapUser: any = { ...result, idUser: result.id }
            dispatch(auth.actions.login(result.api_token, mapUser))
            dispatch(auth.actions.setSaml(result))
            callSP('amd_getAlertasByUsuario', [
              { text: 'usuario', value: result.id.toString() },
            ]).then(({ data }) => {
              if (Array.isArray(data.result)) {
                dispatch(auth.actions.setNotifications(data.result))
              }
              setLoading(false)
            }).catch((e: any) => {
              setLoading(false)
              setSubmitting(false)
              setStatus('The notifications detail is failed')
            })
          })
          .catch(() => {
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })
  setTimeout(() => {
    localStorage.clear();
  }, 800);
  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Iniciar Sesión AMD Sodexo</h1>
        <div className='text-gray-400 fw-bold fs-4'>
          ¿Eres nuevo?{' '}
          <Link to='/auth/registration' className='link-primary fw-bolder'>
            Crear Cuenta
          </Link>
        </div>
      </div>
      {/* begin::Heading */}

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <div className='mb-10 bg-light-info p-8 rounded'>
          <div className='text-info'>

          </div>
        </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>Usuario</label>
        <input
          placeholder='User'
          {...formik.getFieldProps('user')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            { 'is-invalid': formik.touched.user && formik.errors.user },
            {
              'is-valid': formik.touched.user && !formik.errors.user,
            }
          )}
          type='text'
          name='user'
          autoComplete='off'
        />
        {formik.touched.user && formik.errors.user && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.user}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Contraseña</label>
            {/* end::Label */}
            {/* begin::Link */}
            <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{ marginLeft: '15px' }}
            >
              ¿Olvidaste tu contraseña ?
            </Link>
            {/* end::Link */}
          </div>
        </div>
        <input
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Continuar</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Por favor espere...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>

        <button
          type='button'
          onClick={() => postSaml("admin", "123456", URL_SAML_RETURN + "")}
          id='kt_sign__salm_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>SAML</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Por favor espere...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </form>

  )
}
